import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import OrderItemListPageUI from './OrderItemListPageUI.js'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

class OrderItemListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      order: null,
      itemList: null,
      filteredItemList: null,
      statusList: null,
      statusFilter: '-1',
      searchFilter: '',
      updateOrderMode: false,
      updateOrderItem: null,
      createOrderItemMode: false,
      updateOrderItemMode: false
    }
  }

  render() {
    return (
      <OrderItemListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        order={this.state.order}
        itemList={this.state.itemList}
        filteredItemList={this.state.filteredItemList}
        statusList={this.state.statusList}
        statusFilter={this.state.statusFilter}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onStatusFilterChange={this.onStatusFilterChange}
        onSearchFilterChange={this.onSearchFilterChange}
        // update modal
        updateOrderMode={this.state.updateOrderMode}
        onUpdateOrderClick={(event) => { this.setState({ updateOrderMode: true }) }}
        onCancelUpdateOrder={(event) => { this.setState({ updateOrderMode: false }) }}
        onUpdateOrderComplete={this.onUpdateOrderComplete}
        // create order item modal
        createOrderItemMode={this.state.createOrderItemMode}
        onCreateOrderItemClick={(event) => { this.setState({ createOrderItemMode: true }) }}
        onCancelCreateOrderItem={(event) => { this.setState({ createOrderItemMode: false }) }}
        onCreateOrderItemComplete={this.onCreateOrderItemComplete}
        // update order item modal
        updateOrderItemMode={this.state.updateOrderItemMode}
        onUpdateOrderItemClick={this.onUpdateOrderItemClick}
        onCancelUpdateOrderItem={(event) => { this.setState({ updateOrderItemMode: false }) }}
        onUpdateOrderItemComplete={this.onUpdateOrderItemComplete}
        updateOrderItem={this.state.updateOrderItem}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getOrder(context)
    // this.getOrderItems(context)
    this.getMessages(context)
    this.getOrderItemStatuses(context)
    Modal.setAppElement('body')
  }

  getOrder(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/estimates/${this.props.match.params.orderId}`,
      cacheKey: CacheKeys.Order(this.props.match.params.orderId),
      callback: this.getOrderCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOrderCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.OrderItemsFilter(this.props.match.params.orderId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      order: response.estimate,
      itemList: response.estimateItemList,
      filteredItemList: response.estimateItemList,
      statusFilter: filters.statusFilter ? filters.statusFilter : '-1',
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.estimateItemList,
      filters.statusFilter ? filters.statusFilter : '-1',
      filters.searchFilter ? filters.searchFilter : '')
  }

  onUpdateOrderComplete = (order) => {
    CacheManager.removeObject(CacheKeys.Order(this.props.match.params.orderId))
    this.setState({ order: order })
    setTimeout(() => {
      this.setState({ updateOrderMode: false })
    }, 2000)
  }

  onUpdateOrderItemClick = (event) => {
    let orderItemId = event.currentTarget.getAttribute('data-row-id')
    let itemList = this.state.itemList
    let item = itemList.find(element => element.orderItemId === orderItemId)

    this.setState({
      updateOrderItemMode: true,
      updateOrderItem: item
    })
  }

  getOrderItems(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/estimates/${this.props.match.params.orderId}`,
      cacheKey: CacheKeys.OrderItems(this.props.match.params.orderId),
      callback: this.getOrderItemsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOrderItemsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.OrderItemsFilter(this.props.match.params.orderId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      itemList: response.orderItemList,
      filteredItemList: response.orderItemList,
      statusFilter: filters.statusFilter ? filters.statusFilter : '-1',
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.orderItemList,
      filters.statusFilter ? filters.statusFilter : '-1',
      filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(itemList, statusFilter, searchFilter) {
    let filteredList = itemList

    if (statusFilter !== '-1')
      filteredList = filteredList.filter(item => item.status === statusFilter)
    if (searchFilter)
      filteredList = filteredList.filter(item =>
        item.itemName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        (item.maker && item.maker.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))
      )

    this.setState({ filteredItemList: filteredList })

    let filters = {
      statusFilter: statusFilter,
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.OrdersFilter(this.props.match.params.orderId), JSON.stringify(filters))
  }

  onStatusFilterChange = (value) => {
    this.setState({ statusFilter: value })
    this.applyFilters(this.state.itemList, value, this.state.searchFilter)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.itemList, this.state.statusFilter, searchFilter)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Order(this.props.match.params.orderId))
    CacheManager.removeObject(CacheKeys.OrderItems(this.props.match.params.orderId))
    this.setState({
      errorList: null,
      itemList: null,
      filteredItemList: null,
      order: null
    }, () => {
      this.getOrder(context)
      this.getOrderItems(context)
    })
  }

  getOrderItemStatuses(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/orderItemStatuses`,
      cacheKey: CacheKeys.OrderItemStatuses(),
      callback: this.getOrderItemStatusesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getOrderItemStatusesCallback = (response) => {
    this.setState({ statusList: response.list.map(item => ({ value: item.key, label: item.value })) })
  }

  onCreateOrderItemComplete = (customerOrder, orderItemList) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.OrderItems(customerOrder.estimateId))
    CacheManager.removeObject(CacheKeys.AccountStats(context.session.accountId))

    let filtersStr = sessionStorage.getItem(CacheKeys.OrderItemsFilter(this.props.match.params.orderId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      itemList: orderItemList,
      filteredItemList: orderItemList,
      statusFilter: filters.statusFilter ? filters.statusFilter : '-1',
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(orderItemList,
      filters.statusFilter ? filters.statusFilter : '-1',
      filters.searchFilter ? filters.searchFilter : '')

    setTimeout(() => {
      //this.setState({ createOrderItemMode: false })
    }, 2000)
  }

  onUpdateOrderItemComplete = (customerOrder, orderItemList) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.OrderItems(customerOrder.estimateId))
    CacheManager.removeObject(CacheKeys.AccountStats(context.session.accountId))
    this.getOrderItems(context)

    setTimeout(() => {
      this.setState({ updateOrderItemMode: false })
    }, 2000)
  }

  getMessages(context) {
    let arr = [
      'c_order_items',
      'c_refresh',
      'c_add_ord_item',
      'c_no_item_msg',
      'c_qty',
      'c_all',
      'c_due_date',
      'c_cust_order',
      'c_order_date',
      'c_status_done',
      'c_completion_date',
      'c_order_total',
      'c_completion',
      'c_items',
      'c_budgets',
      'c_invoices',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_ord_items', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(OrderItemListPageSF)
